import { ENV_STORAGE_SUFFIX } from '../constants/apis'

function makeKey(email?: string | null): string {
  return `orgTierFilter:${email || 'global'}${ENV_STORAGE_SUFFIX}`
}

export const orgTierPreferenceStorage = {
  get(email?: string | null): string | null {
    try {
      return localStorage.getItem(makeKey(email))
    } catch (e) {
      console.error('[orgTierPreferenceStorage] Failed to get tier', e)
      return null
    }
  },

  set(tier: string, email?: string | null): void {
    try {
      localStorage.setItem(makeKey(email), tier)
    } catch (e) {
      console.error('[orgTierPreferenceStorage] Failed to set tier', e)
    }
  }
}
